import { ListaPerguntaResponse } from 'api/Assessor/duvidas';
import AlteraUrlTransmissaoAssembleia from 'models/AlteraUrlTransmissaoAssembleia';
import AssembleiaProduto from 'models/AssembleiaProduto';
import AssembleiaProdutosPorTipo from 'models/AssembleiaProdutosPorTipo';
import AssembleiaProdutoTipo from 'models/AssembleiaProdutoTipo';
import AssembleiaTipo from 'models/AssembleiaTipo';
import CadastroAssembleia from 'models/CadastroAssembleia';
import { ListaEventoResponse } from 'models/ListaEventoResponse';
import PresencasResponse from 'models/PresencasResponse';
import {
  IAssembleiasAssessorEvent,
  IAssembleiasAssessorEventList,
  IAssembleiasAssessorPauta,
  IListaAgenciasPauta,
  IAssembleiaResultadosVotos
} from './AssembleiasAssessorReducer';
import { IWSAssembleia } from './WSAssembleiasReducer';
import TipoDocumento from 'models/TipoDocumento';
import TipoDocumentoRequest from 'models/TipoDocumentoRequest';
import { DocumentoRequestUpdate, DocumentoRequestUpload, DocumentoResponse } from 'api/Assessor/documentos';
import TotalizadoresConvocadosResponse from 'models/TotalizadoresConvocadosResponse';
import { AssembleiaContaAssessor } from 'models/AssembleiaContaAssessor';

export const ASSEMBLEIAS_ASSESSOR_DELETAR =
  'ASSEMBLEIAS_ASSESSOR_DELETAR';

export const ASSEMBLEIAS_ASSESSOR_CADASTRAR =
  'ASSEMBLEIAS_ASSESSOR_CADASTRAR';

export const ASSEMBLEIAS_ASSESSOR_EDITAR =
  'ASSEMBLEIAS_ASSESSOR_EDITAR';

export const ASSEMBLEIAS_ASSESSOR_ALTERA_URL_TRANSMISSAO =
  'ASSEMBLEIAS_ASSESSOR_ALTERA_URL_TRANSMISSAO';

export const ASSEMBLEIAS_ASSESSOR_ACTIONS_ALTERAR_STATUS_PAUTA =
  'ASSEMBLEIAS_ASSESSOR_ACTIONS_ALTERAR_STATUS_PAUTA';

export const ASSEMBLEIAS_ASSESSOR_ACTIONS_LIBERAR_PAUTA =
  'ASSEMBLEIAS_ASSESSOR_ACTIONS_LIBERAR_PAUTA';

export const ASSEMBLEIAS_ASSESSOR_ACTIONS_RESULTADO_VOTO_PAUTA =
  'ASSEMBLEIAS_ASSESSOR_ACTIONS_RESULTADO_VOTO_PAUTA';

export const ASSEMBLEIAS_ASSESSOR_ACTIONS_LOAD_RESULTADO_VOTO_PAUTA =
  'ASSEMBLEIAS_ASSESSOR_ACTIONS_LOAD_RESULTADO_VOTO_PAUTA';

export const ASSEMBLEIAS_ASSESSOR_ACTIONS_REQUEST_FILE =
  'ASSEMBLEIAS_ASSESSOR_ACTIONS_REQUEST_FILE';
export const ASSEMBLEIAS_ASSESSOR_ACTIONS_DOWNLOAD_FILE_SUCCESS =
  'ASSEMBLEIAS_ASSESSOR_ACTIONS_DOWNLOAD_FILE_SUCCESS';

export const ASSEMBLEIAS_ASSESSOR_LOADING_EVENTO = 'ASSEMBLEIAS_ASSESSOR_LOADING_EVENTO'; 
export const ASSEMBLEIAS_ASSESSOR_LOAD_EVENTO = 'ASSEMBLEIAS_ASSESSOR_LOAD_EVENTO';
export const ASSEMBLEIAS_ASSESSOR_LOADING_LISTA_EVENTO = 'ASSEMBLEIAS_ASSESSOR_LOADING_LISTA_EVENTO';
export const ASSEMBLEIAS_ASSESSOR_LOAD_LISTA_EVENTO = 'ASSEMBLEIAS_ASSESSOR_LOAD_LISTA_EVENTO';
export const ASSEMBLEIAS_ASSESSOR_LOADING_LISTA_PAGINADA_EVENTO = 'ASSEMBLEIAS_ASSESSOR_LOADING_LISTA_PAGINADA_EVENTO';
export const ASSEMBLEIAS_ASSESSOR_LOAD_LISTA_PAGINADA_EVENTO = 'ASSEMBLEIAS_ASSESSOR_LOAD_LISTA_PAGINADA_EVENTO';
export const ASSEMBLEIAS_ASSESSOR_LOADING_CONTAS = 'ASSEMBLEIAS_ASSESSOR_LOADING_CONTAS';
export const ASSEMBLEIAS_ASSESSOR_LOAD_CONTAS = 'ASSEMBLEIAS_ASSESSOR_LOAD_CONTAS';
export const ASSEMBLEIAS_ASSESSOR_ACTIONS_DELETE_CURRENT_EVENT = 'ASSEMBLEIAS_ASSESSOR_ACTIONS_DELETE_CURRENT_EVENT';
export const ASSEMBLEIAS_ASSESSOR_ACTIONS_CLEARED_CURRENT_EVENT = 'ASSEMBLEIAS_ASSESSOR_ACTIONS_CLEARED_CURRENT_EVENT';

export const ASSEMBLEIAS_ASSESSOR_LOADING_PAUTAS = 'ASSEMBLEIAS_ASSESSOR_LOADING_PAUTAS';
export const ASSEMBLEIAS_ASSESSOR_LOAD_PAUTAS = 'ASSEMBLEIAS_ASSESSOR_LOAD_PAUTAS';
export const ASSEMBLEIAS_ASSESSOR_FORCE_LOAD_PAUTAS = 'ASSEMBLEIAS_ASSESSOR_FORCE_LOAD_PAUTAS';
export const ASSEMBLEIAS_ASSESSOR_ALTERANDO_STATUS_PAUTA = 'ASSEMBLEIAS_ASSESSOR_ALTERANDO_STATUS_PAUTA';
export const ASSEMBLEIAS_ASSESSOR_LOADING_AGENCIAS_PAUTA = 'ASSEMBLEIAS_ASSESSOR_LOADING_AGENCIAS_PAUTA';
export const ASSEMBLEIAS_ASSESSOR_LOAD_AGENCIAS_PAUTA = 'ASSEMBLEIAS_ASSESSOR_LOAD_AGENCIAS_PAUTA';
export const ASSEMBLEIAS_ASSESSOR_BUSCAR_PAUTA = 'ASSEMBLEIAS_ASSESSOR_BUSCAR_PAUTA';

export const ASSEMBLEIAS_ASSESSOR_LOADING_DUVIDAS = 'ASSEMBLEIAS_ASSESSOR_LOADING_DUVIDAS';
export const ASSEMBLEIAS_ASSESSOR_LOAD_DUVIDAS = 'ASSEMBLEIAS_ASSESSOR_LOAD_DUVIDAS';

export const ASSEMBLEIAS_ASSESSOR_LOADING_PRESENCAS = 'ASSEMBLEIAS_ASSESSOR_LOADING_PRESENCAS';
export const ASSEMBLEIAS_ASSESSOR_LOAD_PRESENCAS = 'ASSEMBLEIAS_ASSESSOR_LOAD_PRESENCAS';

export const ASSEMBLEIAS_ASSESSOR_REGISTRANDO_PRESENCA = 'ASSEMBLEIAS_ASSESSOR_REGISTRANDO_PRESENCA';

export const ASSEMBLEIAS_ASSESSOR_REFRESH = 'ASSEMBLEIAS_ASSESSOR_REFRESH';

export const ASSEMBLEIAS_ASSESSOR_CADASTRANDO_PAUTA = 'ASSEMBLEIAS_ASSESSOR_CADASTRANDO_PAUTA';

export const ASSEMBLEIAS_ASSESSOR_DELETANDO_PAUTA = 'ASSEMBLEIAS_ASSESSOR_DELETAR_PAUTA';

export const ASSEMBLEIAS_ASSESSOR_LOADING_TIPOS = 'ASSEMBLEIAS_ASSESSOR_LOADING_TIPOS';
export const ASSEMBLEIAS_ASSESSOR_LOAD_TIPOS = 'ASSEMBLEIAS_ASSESSOR_LOAD_TIPOS';

export const ASSEMBLEIAS_ASSESSOR_LOADING_PRODUTOS = 'ASSEMBLEIAS_ASSESSOR_LOADING_PRODUTOS';
export const ASSEMBLEIAS_ASSESSOR_LOAD_PRODUTOS = 'ASSEMBLEIAS_ASSESSOR_LOAD_PRODUTOS';

export const ASSEMBLEIAS_ASSESSOR_LOADING_TIPOS_PRODUTO = 'ASSEMBLEIAS_ASSESSOR_LOADING_TIPOS_PRODUTO';
export const ASSEMBLEIAS_ASSESSOR_LOAD_TIPOS_PRODUTO = 'ASSEMBLEIAS_ASSESSOR_LOAD_TIPOS_PRODUTO';

export const ASSEMBLEIAS_ASSESSOR_LOADING_TIPOS_DOCUMENTOS = 'ASSEMBLEIAS_ASSESSOR_LOADING_TIPOS_DOCUMENTOS';
export const ASSEMBLEIAS_ASSESSOR_LOAD_TIPOS_DOCUMENTOS = 'ASSEMBLEIAS_ASSESSOR_LOAD_TIPOS_DOCUMENTOS';
export const ASSEMBLEIAS_ASSESSOR_TIPOS_DOCUMENTOS_CADASTRAR = 'ASSEMBLEIAS_ASSESSOR_TIPOS_DOCUMENTOS_CADASTRAR';
export const ASSEMBLEIAS_ASSESSOR_TIPOS_DOCUMENTOS_ALTERAR = 'ASSEMBLEIAS_ASSESSOR_TIPOS_DOCUMENTOS_ALTERAR';
export const ASSEMBLEIAS_ASSESSOR_DELETANDO_TIPO_DOCUMENTO = 'ASSEMBLEIAS_ASSESSOR_DELETAR_TIPO_DOCUMENTO';

export const ASSEMBLEIAS_ASSESSOR_LOADING_PRODUTOS_POR_TIPO = 'ASSEMBLEIAS_ASSESSOR_LOADING_PRODUTOS_POR_TIPO';
export const ASSEMBLEIAS_ASSESSOR_LOAD_PRODUTOS_POR_TIPO = 'ASSEMBLEIAS_ASSESSOR_LOAD_PRODUTOS_POR_TIPO';

export const ASSEMBLEIAS_ASSESSOR_LOADING_TOTALIZADORES_CONVOCADOS = 'ASSEMBLEIAS_ASSESSOR_LOADING_TOTALIZADORES_CONVOCADOS';
export const ASSEMBLEIAS_ASSESSOR_LOAD_TOTALIZADORES_CONVOCADOS = 'ASSEMBLEIAS_ASSESSOR_LOAD_TOTALIZADORES_CONVOCADOS';

export const ASSEMBLEIAS_ASSESSOR_ATUALIZANDO_CONVOCADOS = 'ASSEMBLEIAS_ASSESSOR_ATUALIZANDO_CONVOCADOS';
export const ASSEMBLEIAS_ASSESSOR_ATUALIZAR_CONVOCADOS = 'ASSEMBLEIAS_ASSESSOR_ATUALIZAR_CONVOCADOS';

export const ASSEMBLEIAS_ASSESSOR_BLOQUEANDO_CONVOCACOES = 'ASSEMBLEIAS_ASSESSOR_BLOQUEANDO_CONVOCACOES';
export const ASSEMBLEIAS_ASSESSOR_BLOQUEAR_CONVOCACOES = 'ASSEMBLEIAS_ASSESSOR_BLOQUEAR_CONVOCACOES';

export const ASSEMBLEIAS_ASSESSOR_LOADING_DOCUMENTOS = 'ASSEMBLEIAS_ASSESSOR_LOADING_DOCUMENTOS';
export const ASSEMBLEIAS_ASSESSOR_LOAD_DOCUMENTOS = 'ASSEMBLEIAS_ASSESSOR_LOAD_DOCUMENTOS';
export const ASSEMBLEIAS_ASSESSOR_DOCUMENTOS_CADASTRAR = 'ASSEMBLEIAS_ASSESSOR_DOCUMENTOS_CADASTRAR';
export const ASSEMBLEIAS_ASSESSOR_DOCUMENTOS_ALTERAR = 'ASSEMBLEIAS_ASSESSOR_DOCUMENTOS_ALTERAR';
export const ASSEMBLEIAS_ASSESSOR_DELETANDO_DOCUMENTO = 'ASSEMBLEIAS_ASSESSOR_DELETAR_DOCUMENTO';

export const ASSEMBLEIAS_ASSESSOR_ACTIONS_REGISTRA_VOTO =
  'ASSEMBLEIAS_ASSESSOR_ACTIONS_REGISTRA_VOTO';
export interface IAssembleiaAssessorDeletar {
  type: typeof ASSEMBLEIAS_ASSESSOR_DELETAR;
  payload: number
}

export interface IAssembleiaAssessorCadastrar {
  type: typeof ASSEMBLEIAS_ASSESSOR_CADASTRAR;
  payload: CadastroAssembleia
}

export interface IAssembleiaAssessorEditar {
  type: typeof ASSEMBLEIAS_ASSESSOR_EDITAR;
  payload: CadastroAssembleia
}

export interface IAssembleiaAssessorAlteraUrlTransmissao {
  type: typeof ASSEMBLEIAS_ASSESSOR_ALTERA_URL_TRANSMISSAO;
  payload: AlteraUrlTransmissaoAssembleia
}

export interface IAssembleiaAssessorAlterarSituacaoPauta {
  type: typeof ASSEMBLEIAS_ASSESSOR_ACTIONS_ALTERAR_STATUS_PAUTA;
}

export interface IAssembleiaAssessorLiberarPauta {
  type: typeof ASSEMBLEIAS_ASSESSOR_ACTIONS_LIBERAR_PAUTA;
}

export interface IAssembleiaAssessorLoadResultadoVotos {
  type: typeof ASSEMBLEIAS_ASSESSOR_ACTIONS_LOAD_RESULTADO_VOTO_PAUTA;
}
export interface IAssembleiaAssessorResultadoVotos {
  type: typeof ASSEMBLEIAS_ASSESSOR_ACTIONS_RESULTADO_VOTO_PAUTA;
  payload: IAssembleiaResultadosVotos;
}

export interface IAssembleiaAssessorRequestFile {
  type: typeof ASSEMBLEIAS_ASSESSOR_ACTIONS_REQUEST_FILE;
  payload: number[];
}

export interface IAssembleiaAssessorDownloadFileSuccess {
  type: typeof ASSEMBLEIAS_ASSESSOR_ACTIONS_DOWNLOAD_FILE_SUCCESS;
  payload: number[];
}

export interface IAssembleiasAssessorLoadingEvento {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOADING_EVENTO,
  payload: boolean
}

export interface IAssembleiasAssessorLoadEvento {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOAD_EVENTO,
  payload: IAssembleiasAssessorEvent
}

export interface IAssembleiasAssessorLoadingListaEvento {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOADING_LISTA_EVENTO,
  payload: boolean
}

export interface IAssembleiasAssessorLoadListaEvento {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOAD_LISTA_EVENTO,
  payload: IAssembleiasAssessorEventList[]
}

export interface IAssembleiasAssessorLoadingListaPaginadaEvento {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOADING_LISTA_PAGINADA_EVENTO,
  payload: boolean
}

export interface IAssembleiasAssessorLoadListaPaginadaEvento {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOAD_LISTA_PAGINADA_EVENTO,
  payload: ListaEventoResponse
}

export interface IAssembleiasAssessorLoadingPautas {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOADING_PAUTAS,
  payload: boolean
}

export interface IAssembleiaAssessorLoadPautas {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOAD_PAUTAS,
  payload: IAssembleiasAssessorPauta[]
}

export interface IAssembleiaAssessorForceLoadPautas {
  type: typeof ASSEMBLEIAS_ASSESSOR_FORCE_LOAD_PAUTAS,
}

export interface IAssembleiasAssessorAlterandoStatusPauta {
  type: typeof ASSEMBLEIAS_ASSESSOR_ALTERANDO_STATUS_PAUTA,
  payload: boolean
}

export interface IAssembleiasAssessorLoadingContas {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOADING_CONTAS,
  payload: boolean
}

export interface IAssembleiasAssessorLoadContas {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOAD_CONTAS,
  payload: AssembleiaContaAssessor[]
}

export interface IAssembleiasAssessorLoadingDuvidas {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOADING_DUVIDAS,
  payload: boolean
}

export interface IAssembleiasAssessorLoadDuvidas {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOAD_DUVIDAS;
  payload: ListaPerguntaResponse;
}

export interface IAssembleiasAssessorLoadingPresencas {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOADING_PRESENCAS,
  payload: boolean
}

export interface IAssembleiasAssessorLoadPresencas {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOAD_PRESENCAS;
  payload: PresencasResponse;
}

export interface IAssembleiasAssessorRegistrandoPresenca {
  type: typeof ASSEMBLEIAS_ASSESSOR_REGISTRANDO_PRESENCA,
  payload: boolean
}

export interface IAssembleiasAssessorDeleteCurrentEvent {
  type: typeof ASSEMBLEIAS_ASSESSOR_ACTIONS_DELETE_CURRENT_EVENT;
  payload: undefined;
}

export interface IAssembleiasAssessorClearedCurrentEvent {
  type: typeof ASSEMBLEIAS_ASSESSOR_ACTIONS_CLEARED_CURRENT_EVENT;
  payload: undefined;
}

export interface IAssembleiasAssessorLoadingAgenciasPauta {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOADING_AGENCIAS_PAUTA,
  payload: boolean
}

export interface IAssembleiasAssessorLoadAgenciasPauta {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOAD_AGENCIAS_PAUTA,
  payload: IListaAgenciasPauta[]
}

export interface IAssembleiaAssessorBuscarPauta {
  type: typeof ASSEMBLEIAS_ASSESSOR_BUSCAR_PAUTA,
  idAssembleia: number,
  payload: IAssembleiasAssessorPauta[]
}

export interface IAssembleiasAssessorRefresh {
  type: typeof ASSEMBLEIAS_ASSESSOR_REFRESH,
  payload: IWSAssembleia
}

export interface IAssembleiasAssessorCadastrandoPauta {
  type: typeof ASSEMBLEIAS_ASSESSOR_CADASTRANDO_PAUTA,
  payload: boolean
}

export interface IAssembleiaAssessorDeletandoPauta {
  type: typeof ASSEMBLEIAS_ASSESSOR_DELETANDO_PAUTA,
  payload: boolean
}

export interface IAssembleiaAssessorLoadingTipos {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOADING_TIPOS;
  payload: boolean;
}

export interface IAssembleiaAssessorLoadTipos {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOAD_TIPOS;
  payload: AssembleiaTipo[]
}

export interface IAssembleiaAssessorLoadingTipoDocumento {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOADING_TIPOS_DOCUMENTOS;
  payload: boolean;
}

export interface IAssembleiaAssessorLoadTipoDocumento {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOAD_TIPOS_DOCUMENTOS;
  payload: TipoDocumento[];
}

export interface IAssembleiaAssessorTipoDocumentoCadastrar {
  type: typeof ASSEMBLEIAS_ASSESSOR_TIPOS_DOCUMENTOS_CADASTRAR;
  payload: TipoDocumentoRequest;
}

export interface IAssembleiaAssessorTipoDocumentoAlterar {
  type: typeof ASSEMBLEIAS_ASSESSOR_TIPOS_DOCUMENTOS_ALTERAR;
  payload: TipoDocumentoRequest;
}

export interface IAssembleiaAssessorDeletarTipoDocumento {
  type: typeof ASSEMBLEIAS_ASSESSOR_DELETANDO_TIPO_DOCUMENTO;
  payload: boolean;
}

export interface IAssembleiaAssessorLoadingProdutos {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOADING_PRODUTOS;
  payload: boolean;
}

export interface IAssembleiaAssessorLoadProdutos {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOAD_PRODUTOS;
  payload: AssembleiaProduto[]
}

export interface IAssembleiaAssessorLoadingTiposProduto {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOADING_TIPOS_PRODUTO;
  payload: boolean;
}

export interface IAssembleiaAssessorLoadTiposProduto {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOAD_TIPOS_PRODUTO;
  payload: AssembleiaProdutoTipo[]
}

export interface IAssembleiaAssessorLoadingProdutosPorTipo {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOADING_PRODUTOS_POR_TIPO;
  payload: boolean;
}

export interface IAssembleiaAssessorLoadProdutosPorTipo {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOAD_PRODUTOS_POR_TIPO;
  payload: AssembleiaProdutosPorTipo
}

export interface IAssembleiasAssessorLoadingTotalizadoresConvocados {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOADING_TOTALIZADORES_CONVOCADOS,
  payload: boolean
}
export interface IAssembleiasAssessorLoadTotalizadoresConvocados {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOAD_TOTALIZADORES_CONVOCADOS;
  payload: TotalizadoresConvocadosResponse;
}

export interface AssembleiaAssessorAtualizandoConvocados {
  type: typeof ASSEMBLEIAS_ASSESSOR_ATUALIZANDO_CONVOCADOS;
  payload: boolean;
}

interface AssembleiaAssessorAtualizarConvocadosPayload {
  idAssembleia: number;
  flgConvocado: boolean;
}

export interface AssembleiaAssessorAtualizarConvocados {
  type: typeof ASSEMBLEIAS_ASSESSOR_ATUALIZAR_CONVOCADOS;
  payload: AssembleiaAssessorAtualizarConvocadosPayload;
}

export interface AssembleiaAssessorBloqueandoConvocacoes {
  type: typeof ASSEMBLEIAS_ASSESSOR_BLOQUEANDO_CONVOCACOES;
  payload: boolean;
}

interface AssembleiaAssessorBloquearConvocacoesPayload {
  idAssembleia: number;
  flgBloqueio: boolean;
}

export interface AssembleiaAssessorBloquearConvocacoes {
  type: typeof ASSEMBLEIAS_ASSESSOR_BLOQUEAR_CONVOCACOES;
  payload: AssembleiaAssessorBloquearConvocacoesPayload;
}

export interface IAssembleiaAssessorLoadingDocumento {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOADING_DOCUMENTOS;
  payload: boolean;
}

export interface IAssembleiaAssessorLoadDocumento {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOAD_DOCUMENTOS;
  payload: DocumentoResponse[];
}

export interface IAssembleiaAssessorDocumentoCadastrar {
  type: typeof ASSEMBLEIAS_ASSESSOR_DOCUMENTOS_CADASTRAR;
  payload: DocumentoRequestUpload;
}

export interface IAssembleiaAssessorDocumentoAlterar {
  type: typeof ASSEMBLEIAS_ASSESSOR_DOCUMENTOS_ALTERAR;
  payload: DocumentoRequestUpdate;
}

export interface IAssembleiaAssessorDeletarDocumento {
  type: typeof ASSEMBLEIAS_ASSESSOR_DELETANDO_DOCUMENTO;
  payload: boolean;
}

export interface IAssembleiasAssessorRegistraVoto {
  type: typeof ASSEMBLEIAS_ASSESSOR_ACTIONS_REGISTRA_VOTO;
}

export type AssembleiasAssessorActionTypes =
  | IAssembleiaAssessorDeletar
  | IAssembleiaAssessorCadastrar
  | IAssembleiaAssessorEditar
  | IAssembleiaAssessorAlteraUrlTransmissao
  | IAssembleiaAssessorAlterarSituacaoPauta
  | IAssembleiaAssessorRequestFile
  | IAssembleiaAssessorDownloadFileSuccess
  | IAssembleiasAssessorLoadingEvento
  | IAssembleiasAssessorLoadEvento
  | IAssembleiasAssessorLoadingListaEvento
  | IAssembleiasAssessorLoadListaEvento
  | IAssembleiasAssessorLoadingListaPaginadaEvento
  | IAssembleiasAssessorLoadListaPaginadaEvento
  | IAssembleiasAssessorLoadingPautas
  | IAssembleiaAssessorLoadPautas
  | IAssembleiaAssessorForceLoadPautas
  | IAssembleiasAssessorAlterandoStatusPauta
  | IAssembleiasAssessorLoadingContas
  | IAssembleiasAssessorLoadContas
  | IAssembleiasAssessorLoadingDuvidas
  | IAssembleiasAssessorLoadDuvidas
  | IAssembleiasAssessorLoadingPresencas
  | IAssembleiasAssessorLoadPresencas
  | IAssembleiasAssessorRegistrandoPresenca
  | IAssembleiasAssessorDeleteCurrentEvent
  | IAssembleiasAssessorClearedCurrentEvent
  | IAssembleiasAssessorLoadingAgenciasPauta
  | IAssembleiasAssessorLoadAgenciasPauta
  | IAssembleiasAssessorRefresh
  | IAssembleiasAssessorCadastrandoPauta
  | IAssembleiaAssessorDeletandoPauta
  | IAssembleiaAssessorLoadingTipos
  | IAssembleiaAssessorLoadTipos
  | IAssembleiaAssessorLoadingProdutos
  | IAssembleiaAssessorLoadProdutos
  | IAssembleiaAssessorLoadingTiposProduto
  | IAssembleiaAssessorLoadTiposProduto
  | IAssembleiaAssessorLoadingProdutosPorTipo
  | IAssembleiaAssessorLoadProdutosPorTipo
  | AssembleiaAssessorAtualizandoConvocados
  | AssembleiaAssessorAtualizarConvocados
  | AssembleiaAssessorBloqueandoConvocacoes
  | AssembleiaAssessorBloquearConvocacoes
  | IAssembleiaAssessorLoadingTipoDocumento
  | IAssembleiaAssessorLoadTipoDocumento
  | IAssembleiaAssessorTipoDocumentoCadastrar
  | IAssembleiaAssessorTipoDocumentoAlterar
  | IAssembleiaAssessorDeletarTipoDocumento
  | IAssembleiaAssessorLoadingDocumento
  | IAssembleiaAssessorLoadDocumento
  | IAssembleiaAssessorDocumentoAlterar
  | IAssembleiaAssessorDocumentoCadastrar
  | IAssembleiaAssessorDeletarDocumento
  | IAssembleiaAssessorLiberarPauta
  | IAssembleiaAssessorLoadResultadoVotos
  | IAssembleiaAssessorResultadoVotos
  | IAssembleiasAssessorLoadingTotalizadoresConvocados
  | IAssembleiasAssessorLoadTotalizadoresConvocados
  | IAssembleiaAssessorBuscarPauta
  | IAssembleiasAssessorRegistraVoto